export enum RoleName {
    Administrator = 'Administrator',
    CustomerExperienceExecutive = 'Customer experience executive',
    CustomerExperienceExecutiveTeamLeader = 'Customer experience executive team leader',
    DataCreationExecutive = 'Data creation executive',
    DataCreationTeamLeader = 'Data creation team leader',
    HeadOfCustomerExperienceTeam = 'Head of Customer Experience Team',
    HoD = 'PP Key Stakeholder',
    InternalKeyStakeholder = 'Internal Key Stakeholder',
    LegalAdvisor = 'Legal advisor',
    LegalAssistant = 'Legal assistant',
    ManageDuplicates = 'Manage duplicates',
    ProbateLegalAdvisor = 'Probate legal advisor',
    System = 'System',
}
